<template>
  <div>
    <div>
      <HeaderTip>
        &nbsp;&nbsp;&nbsp;&nbsp;
        数量：{{selectCount}}&nbsp;&nbsp;&nbsp;&nbsp;金额：{{toRound(selectAmount)}} 元
        &nbsp;&nbsp;&nbsp;&nbsp;
      </HeaderTip>
      <div class="header-btn">
        <el-badge :value="all_count" class="btn-item">
          <el-link @click="onLabelBtn()">全部</el-link>
        </el-badge>
        <template v-for="(item,index) in label_type_list">
          <el-badge :key="index" :value="item.count" class="btn-item">
            <el-link @click="onLabelBtn(item)">{{ item.name }}</el-link>
          </el-badge>
        </template>
      </div>
      <div class="table-wrap">
        <el-table
          v-loading="loading" :data="pageData.data"
          border
          height="40vh"
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column type="selection" width="45" fixed></el-table-column>
          <el-table-column
            prop="HouseName"
            label="房产" min-width="320" fixed></el-table-column>
          <el-table-column
            prop="name"
            label="业主姓名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="业主电话"
            width="180">
          </el-table-column>
          <el-table-column
            prop="butler_name"
            label="催费人员"
            width="100">
          </el-table-column>
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="type_tip"
            label="催费方式"
            width="90">
          </el-table-column>
          <el-table-column
            prop="计划类型"
            label="计划类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="money"
            label="回款金额"
            width="150">
          </el-table-column>
          <el-table-column
            prop="send_time"
            label="催费日期"
            width="100">
          </el-table-column>
          <el-table-column
            prop="业主诉求"
            label="业主原话"
            width="150">
          </el-table-column>
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第一次催费时间"
            label="第一次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第二次催费时间"
            label="第二次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第三次催费时间"
            label="第三次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="添加时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="flow_status"
            label="审核状态"
            width="80">
          </el-table-column>
          <el-table-column
            prop="task_id"
            label="审批流程"
            width="150">
            <template slot-scope="scope">
              <el-link v-if="scope.row.task_id" type="primary" size="mini" @click="openFlow(scope.row)">查看审批</el-link>
            </template>
          </el-table-column>
          <el-table-column
            label="	操作"
            width="180" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-view" @click="preView(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :current-page="pageData.current_page"
          :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500]"
          :page-size="pageData.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total">
        </el-pagination>
      </div>
    </div>

    <ViewFlow ref="viewFlowRef" />
    <LegalHouseInfo ref="LegalHouseInfo" />
  </div>
</template>

<script>
import ViewFlow from "../../../Common/ViewFlow";
import LegalHouseInfo from "../LegalHouseInfo";
import ButlerHttp from "../../common/ButlerHttp";
import HeaderTip from "../../../Common/header-tip";
export default {
  name: "ThirdPartyCompanyProjectMonthDetailsList",
  components: {HeaderTip, LegalHouseInfo, ViewFlow},
  props:{
    urgeType:{
      type: Number|String,
      default: 0
    },
    projectId:{
      type: Number|String,
      default: 0
    },
    startTime:{
      type: String,
      default: "2026-02-01"
    },
    endTime:{
      type: String,
      default: "2026-02-28"
    },
  },
  data() {
    return {
      label_type_list:[],
      where:{
        urge_type:this.urgeType,
        project_id:this.projectId,
        start_time:this.startTime,
        end_time:this.endTime,
        type:0,
        type_ex:0,
      },
      pageData:{
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      all_count:0,
      loading: false,
      multipleSelection: [],
    }
  },
  mounted() {
    this.getList();
    this.getAjaxCount();
  },
  methods:{
    getList() {
      const that = this;
      if(!that.projectId){
        that.loading = false;
        return;
      }
      that.loading = true;
      that.where.urge_type = that.urgeType;
      that.where.project_id = that.projectId;
      that.where.start_time = that.startTime;
      that.where.end_time = that.endTime;
      let where = ERP.reJson(that.where)

      ButlerHttp.post("ThirdPartyCommon/getRecordList?page="+that.pageData.current_page+"&list_rows="+that.pageData.per_page, {
        ...where,
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getAjaxCount() {
      const that = this;
      if(!that.projectId){
        that.loading = false;
        return;
      }
      that.where.urge_type = that.urgeType;
      that.where.project_id = that.projectId;
      that.where.start_time = that.startTime;
      that.where.end_time = that.endTime;
      let where = ERP.reJson(that.where)

      ButlerHttp.post("ThirdPartyCommon/getRecordAjaxCount", {
        ...where,
      }, res => {
        if (res.code) {
          that.label_type_list = res.data;
          that.all_count = res.data.reduce((p, n) => {
            return p + (n.type === 10 ? 0 : n.count);
          }, 0);
        }
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    handleSizeChange(i) {
      this.pageData.per_page = i
      this.pageChange(1)
    },
    onLabelBtn(item=null){
      this.where.type=(item||{}).type||"";
      this.where.type_ex=(item||{}).type_ex||"";
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
    },
    handleSelectionChange(val) {
      const that=this;
      that.multipleSelection = val;
    },
    preView(item){
      this.$refs.LegalHouseInfo.show(item)
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    toRound(num, n=2){
      return Math.round(num*Math.pow(10,n))/Math.pow(10,n)
    }
  },
  computed:{
    selectAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur.money||0)*1)
      },0)
    },
    selectCount(){
      return this.multipleSelection.length
    },
  }
}
</script>

<style lang="scss" scoped>
.header-btn{
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }
}
.pagination-wrap{
  margin-top: 10px;
  text-align: center;
}


</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectMonthDetailsList.vue